/* eslint-disable*/
import React from 'react';
import { Grid, Button, Typography, Box, Paper } from '@material-ui/core';
import Carousel from 'react-material-ui-carousel';
import { ReactComponent as EditPenIconGreen } from '../../../assets/images/EditPenGreen.svg';
import { backendLocalUrl, FROM } from '../../../constants/globalConstants';
import ShowMoreText from 'react-show-more-text';

const ClubBox = ({ club, isAccessible, publicView }) => {
  const executeOnClick = (isExpanded) => {};

  return (
    /*  <Grid item xs={12} sm={4}>
     */
    <Box className="AmenitiesSliderBox">
      <Box className="SliderContainer">
        <Carousel
          navButtonsAlwaysVisible={true}
          autoPlay={false}
          className="SliderCarousel"
          navButtonsProps={{
            style: {
              backgroundColor: '#000',
              padding: '0',
            },
          }}
          indicatorIconButtonProps={{
            style: {
              padding: '0px',
              color: 'rgba(255, 255, 255, 0.6)',
            },
          }}
          activeIndicatorIconButtonProps={{
            style: {
              padding: '0px',
              color: 'rgba(255, 255, 255, 1)',
            },
          }}
          indicatorContainerProps={{
            style: {
              marginTop: '0px',
              position: 'absolute',
              bottom: '5px',
            },
          }}
        >
          {club?.clubGallery && club.clubGallery.length > 0 ? (
            club.clubGallery.map((image, i) => (
              <Paper key={i}>
                <Box className="CardBannerBox">
                  <img
                    src={
                      window.location.hostname === 'localhost'
                        ? `${backendLocalUrl}/${image.image}`
                        : `api/${image.image}`
                    }
                  />
                </Box>
              </Paper>
            ))
          ) : (
            <Paper key="club-no-image">
              <Box className="CardBannerBox">
                <img
                  src={
                    window.location.hostname === 'localhost'
                      ? `${backendLocalUrl}/assets/images/NoImage.png`
                      : `api/assets/images/NoImage.png`
                  }
                  alt="No Image"
                />
              </Box>
            </Paper>
          )}
        </Carousel>
      </Box>
      <Box className="SliderInfoContent">
        <Typography variant="h6" className="AmenitiesCategory">
          {club?.clubCategory?.clubCategoryName}
        </Typography>
        <Typography variant="h3" className="AmenitiesName">
          {club?.clubName}
        </Typography>
        <Box className="AmenitiesAddess">
          <Typography variant="caption" className="AmenitiesInsightLabel">
            Address
          </Typography>
          <Typography variant="body2" className="AmenitiesInsight">
            {club?.clubAddress || '-'}
          </Typography>
        </Box>
        <Box className="AmenitiesText">
          <Typography variant="caption" className="AmenitiesInsightLabel">
            Description
          </Typography>
          <Typography variant="body2" className="AmenitiesInsight">
            <ShowMoreText
              lines={3}
              more="Show More"
              less="Show Less"
              className="ReadMoreBox NoArrow"
              anchorClass="show-more-less-clickable"
              onClick={executeOnClick}
              expanded={false}
              truncatedEndingComponent={'... '}
            >
              {club?.clubDesc || '-'}
            </ShowMoreText>
          </Typography>
        </Box>
        {isAccessible && !publicView && (
          <Button
            className="SelectAmenityButton"
            variant="outlined"
            color="primary"
            fullWidth
            href={`/#/app/community-details-edit-add-new-club/${FROM.CLUBS_LIST}/${club?.communityId}/${club?.id}`}
          >
            Select
          </Button>
        )}
      </Box>
    </Box>
    /*  </Grid> */
  );
};

export default ClubBox;
